
<div class="notice-root-container">
  <div class="notice-overlay"></div>
  <div class="dashborad-below-large page-content" [innerHTML]="infoPageContent">
  </div>
  <div class="order-page-navigator" (click)="hideOfferPanel()">
    <span class="fa fa-angle-right"></span>
  </div>
</div>
